<mat-card class="work-habits-card">
  <div class="habits-header">
    <div>
      <mat-card-title class="habits-title">Work Habits &amp; Routine</mat-card-title>
      <p class="habits-subtitle" *ngIf="habitsData?.captured_days">
        Based on {{ habitsData.captured_days }} captured workdays in the last {{ windowDays }} days
      </p>
    </div>
    <mat-icon
      class="habits-info"
      [matTooltip]="'A summary of this employee\'s active work rhythm over the last ' + windowDays + ' days. This card uses its own window and is not affected by the date filters on this page. Times are shown in the reporting timezone.'">
      info_outline
    </mat-icon>
  </div>

  <div class="habits-skeleton" *ngIf="loading" aria-label="Loading work habits">
    <ngx-skeleton-loader
      *ngFor="let row of [1, 2, 3, 4, 5, 6, 7, 8]"
      [theme]="{ height: '28px', 'margin-bottom': '8px', 'border-radius': '4px' }">
    </ngx-skeleton-loader>
  </div>

  <div class="habits-empty" *ngIf="!loading && error">
    <mat-icon>error_outline</mat-icon>
    <p>Work habits could not be loaded.</p>
    <button mat-stroked-button type="button" (click)="retry()">Try again</button>
  </div>

  <div class="habits-empty" *ngIf="!loading && !error && (!habitsData || !habitsData.has_enough_data)">
    <mat-icon>schedule</mat-icon>
    <p>Not enough tracking data</p>
    <span>Work habits appear after at least 3 meaningful captured workdays.</span>
  </div>

  <div class="habits-content" *ngIf="!loading && !error && habitsData?.has_enough_data">
    <table class="habits-table">
      <thead>
        <tr>
          <th scope="col">Key Metrics</th>
          <th scope="col" class="value-column">Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Screen Time (hrs/day)
            <mat-icon matTooltip="Average active screen time on meaningful workdays">help_outline</mat-icon>
          </td>
          <td class="value-column">
            {{ habitsData.screen_time_hours_per_day == null ? '-' : (habitsData.screen_time_hours_per_day | number:'1.1-1') + ' hrs' }}
          </td>
        </tr>
        <tr>
          <td>
            Productivity Efficiency %
            <mat-icon matTooltip="Active time as a percentage of active plus idle tracked time">help_outline</mat-icon>
          </td>
          <td class="value-column">
            {{ habitsData.productivity_efficiency_pct == null ? '-' : (habitsData.productivity_efficiency_pct | number:'1.0-1') + '%' }}
          </td>
        </tr>
        <tr class="level-row">
          <td>
            Utilization Level
            <mat-icon matTooltip="Healthy is 4.8–10.4 active hours/day; values outside that range are review signals">help_outline</mat-icon>
          </td>
          <td class="value-column">
            <span class="utilization-badge" [ngClass]="'badge-' + habitsData.utilization_badge.variant">
              {{ habitsData.utilization_badge.label }}
            </span>
          </td>
        </tr>
        <tr class="submetric-row">
          <td>Days Overutilized (&gt;10.4h)</td>
          <td class="value-column metric-danger">{{ habitsData.days_breakdown.overutilized_days }}</td>
        </tr>
        <tr class="submetric-row">
          <td>Days Healthy (4.8–10.4h)</td>
          <td class="value-column metric-success">{{ habitsData.days_breakdown.healthy_days }}</td>
        </tr>
        <tr class="submetric-row">
          <td>Days Underutilized (&lt;4.8h)</td>
          <td class="value-column metric-warning">{{ habitsData.days_breakdown.underutilized_days }}</td>
        </tr>
        <tr>
          <td>
            Avg. Start of Day
            <mat-icon matTooltip="Median first active block across meaningful workdays">help_outline</mat-icon>
          </td>
          <td class="value-column">{{ habitsData.schedule.avg_start_formatted || '-' }}</td>
        </tr>
        <tr>
          <td>
            Avg. End of Day
            <mat-icon matTooltip="Median last active block across meaningful workdays">help_outline</mat-icon>
          </td>
          <td class="value-column">{{ habitsData.schedule.avg_end_formatted || '-' }}</td>
        </tr>
        <tr class="break-row">
          <td>
            Breaks/Day
            <mat-icon [matTooltip]="'Median gaps of at least ' + habitsData.breaks.break_gap_threshold_minutes + ' minutes between active blocks'">help_outline</mat-icon>
          </td>
          <td class="value-column">
            {{ habitsData.breaks.breaks_per_day == null ? '-' : (habitsData.breaks.breaks_per_day | number:'1.1-1') }}
          </td>
        </tr>
        <tr>
          <td>
            Avg. Mins/Break
            <mat-icon matTooltip="Median total break time divided by median break count">help_outline</mat-icon>
          </td>
          <td class="value-column">
            {{ habitsData.breaks.avg_minutes_per_break == null ? '-' : habitsData.breaks.avg_minutes_per_break + ' min' }}
          </td>
        </tr>
      </tbody>
    </table>
    <p class="habits-footnote" *ngIf="habitsData.schedule.timezone">
      Times shown in {{ habitsData.schedule.timezone }}
    </p>
  </div>
</mat-card>
